// import React from "react";
// import { motion } from "framer-motion";
// import { useNavigate } from "react-router-dom";
// import { BackgroundBeams } from "./background-beams.tsx";
// import { useTranslation } from 'react-i18next';
// import { 
//   FaReact, 
//   FaNodeJs, 
//   FaDocker, 
//   FaAws 
// } from "react-icons/fa";
// import { SiSap, SiFlutter } from "react-icons/si";
// import { FiArrowRight, FiChevronDown } from "react-icons/fi";

// const FloatingIcon = ({ children, delay, x, y }) => (
//   <motion.div
//     className="absolute text-slate-400/30 dark:text-neutral-500/25 p-4 bg-slate-50/50 dark:bg-neutral-900/10 backdrop-blur-sm rounded-2xl border border-slate-200/20 dark:border-neutral-800/10 shadow-sm"
//     initial={{ x, y }}
//     animate={{
//       y: [y - 10, y + 10, y - 10],
//       rotate: [0, 5, -5, 0],
//     }}
//     transition={{
//       duration: 6,
//       repeat: Infinity,
//       ease: "easeInOut",
//       delay,
//     }}
//     style={{ position: 'absolute' }}
//   >
//     {children}
//   </motion.div>
// );

// const Header = () => {
//   const { t } = useTranslation(); 
//   const navigate = useNavigate();

//   const containerVariants = {
//     hidden: { opacity: 0 },
//     show: {
//       opacity: 1,
//       transition: {
//         staggerChildren: 0.2,
//       },
//     },
//   };

//   const itemVariants = {
//     hidden: { opacity: 0, y: 30 },
//     show: { 
//       opacity: 1, 
//       y: 0, 
//       transition: { type: "spring", stiffness: 100, damping: 20 } 
//     },
//   };

//   const handleStartProject = () => {
//     navigate("/contactus");
//   };

//   const handleViewWork = () => {
//     navigate("/ourwork");
//   };

//   const stats = [
//     { value: "5+", label: "yearsInBusiness" },
//     { value: "100+", label: "solutionsDelivered" },
//     { value: "95%", label: "customerRetention" },
//   ];

//   return (
//     <div className="relative min-h-screen flex flex-col items-center justify-center overflow-hidden bg-white dark:bg-[#080808] transition-colors duration-500">
//       {/* Dynamic Grid Background Overlay */}
//       <div className="absolute inset-0 bg-[linear-gradient(to_right,#8080800a_1px,transparent_1px),linear-gradient(to_bottom,#8080800a_1px,transparent_1px)] bg-[size:14px_24px] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_0%,#000_70%,transparent_100%)]" />

//       {/* Radiant Gradient Blurs */}
//       <div className="absolute top-20 left-1/4 w-72 h-72 rounded-full bg-blue-400/20 dark:bg-blue-600/10 blur-3xl" />
//       <div className="absolute bottom-20 right-1/4 w-96 h-96 rounded-full bg-purple-400/20 dark:bg-purple-600/10 blur-3xl" />

//       {/* Animated Beams Background */}
//       <BackgroundBeams className="opacity-40 dark:opacity-60" />

//       {/* Floating Tech Icons */}
//       <div className="absolute inset-0 pointer-events-none hidden md:block overflow-hidden">
//         <FloatingIcon delay={0} x="10%" y="20%"><FaReact className="w-10 h-10 text-sky-400" /></FloatingIcon>
//         <FloatingIcon delay={1.5} x="85%" y="15%"><SiFlutter className="w-9 h-9 text-blue-400" /></FloatingIcon>
//         <FloatingIcon delay={0.8} x="15%" y="70%"><FaNodeJs className="w-10 h-10 text-emerald-500" /></FloatingIcon>
//         <FloatingIcon delay={2.3} x="80%" y="65%"><SiSap className="w-11 h-11 text-blue-600 dark:text-blue-400" /></FloatingIcon>
//         <FloatingIcon delay={1.2} x="75%" y="30%"><FaDocker className="w-10 h-10 text-cyan-500" /></FloatingIcon>
//         <FloatingIcon delay={1.9} x="25%" y="45%"><FaAws className="w-9 h-9 text-orange-400" /></FloatingIcon>
//       </div>

//       {/* Main Content Area */}
//       <div className="relative z-10 max-w-5xl mx-auto px-6 pt-32 pb-16 text-center flex flex-col items-center">
//         <motion.div
//           variants={containerVariants}
//           initial="hidden"
//           animate="show"
//           className="flex flex-col items-center gap-6"
//         >
//           {/* Badge */}
//           <motion.div 
//             variants={itemVariants}
//             className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-blue-500/20 dark:border-purple-500/20 bg-blue-50/50 dark:bg-purple-950/10 text-xs font-semibold text-blue-600 dark:text-purple-400 backdrop-blur-sm"
//           >
//             <span className="flex h-2 w-2 relative">
//               <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75"></span>
//               <span className="relative inline-flex rounded-full h-2 w-2 bg-blue-500"></span>
//             </span>
//             {t('welcome')}
//           </motion.div>

//           {/* Headline */}
//           <motion.h1 
//             variants={itemVariants}
//             className="text-4xl sm:text-6xl md:text-7xl font-extrabold tracking-tight font-sans text-slate-900 dark:text-white leading-[1.1] max-w-4xl"
//           >
//             {t('tagline')}
//             <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 dark:from-blue-400 dark:via-purple-400 dark:to-pink-500 drop-shadow-sm">
//               Softkel.
//             </span>
//           </motion.h1>

//           {/* Subheading */}
//           <motion.p 
//             variants={itemVariants}
//             className="text-base sm:text-xl text-slate-600 dark:text-slate-300 max-w-2xl font-normal leading-relaxed mt-2"
//           >
//             {t('subTagLine')}
//           </motion.p>

//           {/* CTA Buttons */}
//           <motion.div 
//             variants={itemVariants}
//             className="flex flex-col sm:flex-row items-center gap-4 mt-6 w-full sm:w-auto"
//           >
//             <button
//               onClick={handleStartProject}
//               className="group relative flex items-center justify-center gap-2 px-6 py-3 w-full sm:w-auto text-sm font-semibold rounded-xl bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white shadow-lg shadow-blue-500/25 dark:shadow-purple-500/10 hover:shadow-xl transition-all duration-300 hover:-translate-y-0.5 active:translate-y-0"
//             >
//               <span>{t('contact_us')}</span>
//               <FiArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
//             </button>

//             <button
//               onClick={handleViewWork}
//               className="flex items-center justify-center gap-2 px-6 py-3 w-full sm:w-auto text-sm font-semibold rounded-xl bg-slate-50 hover:bg-slate-100 dark:bg-neutral-900 dark:hover:bg-neutral-800 text-slate-800 dark:text-slate-200 border border-slate-200 dark:border-neutral-800 transition-all duration-300 hover:-translate-y-0.5 active:translate-y-0"
//             >
//               <span>{t('our_work')}</span>
//             </button>
//           </motion.div>
//         </motion.div>

//         {/* Hero Bottom Stats summary */}
//         <motion.div
//           initial={{ opacity: 0, y: 40 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ delay: 0.8, duration: 0.6 }}
//           className="grid grid-cols-3 gap-6 sm:gap-12 mt-16 max-w-2xl w-full border-t border-slate-200/50 dark:border-neutral-800/50 pt-8"
//         >
//           {stats.map((stat, index) => (
//             <div key={index} className="text-center">
//               <h4 className="text-2xl sm:text-3xl font-extrabold bg-clip-text text-transparent bg-gradient-to-b from-slate-900 to-slate-700 dark:from-white dark:to-neutral-400">
//                 {stat.value}
//               </h4>
//               <p className="text-xs sm:text-sm font-medium text-slate-500 dark:text-neutral-500 mt-1">
//                 {t(stat.label)}
//               </p>
//             </div>
//           ))}
//         </motion.div>
//       </div>

//       {/* Animated Scroll Indicator */}
//       <motion.div
//         animate={{ y: [0, 8, 0] }}
//         transition={{ duration: 1.8, repeat: Infinity, ease: "easeInOut" }}
//         className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 pointer-events-none hidden sm:flex flex-col items-center gap-2 text-slate-400"
//       >
//         <span className="text-[10px] uppercase tracking-widest font-semibold opacity-60">Scroll Down</span>
//         <FiChevronDown className="w-4 h-4" />
//       </motion.div>
//     </div>
//   );
// };

// export default Header;


import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { BackgroundBeams } from "./background-beams.tsx";
import { useTranslation } from "react-i18next";
import {
  FaReact,
  FaNodeJs,
  FaDocker,
  FaAws,
} from "react-icons/fa";
import { SiSap, SiFlutter } from "react-icons/si";
import { FiArrowRight, FiChevronDown } from "react-icons/fi";

// Fixed Floating Icon Component
const FloatingIcon = ({ children, delay, x, y }) => (
  <motion.div
    className="absolute text-slate-400/30 dark:text-neutral-500/25 p-4 bg-slate-50/50 dark:bg-neutral-900/10 backdrop-blur-sm rounded-2xl border border-slate-200/20 dark:border-neutral-800/10 shadow-sm"
    style={{
      left: x,
      top: y,
    }}
    animate={{
      y: [-10, 10, -10],
      rotate: [0, 5, -5, 0],
    }}
    transition={{
      duration: 6,
      repeat: Infinity,
      ease: "easeInOut",
      delay,
    }}
  >
    {children}
  </motion.div>
);

const Header = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const containerVariants = {
    hidden: {
      opacity: 0,
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 30,
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        type: "spring",
        stiffness: 100,
        damping: 20,
      },
    },
  };

  const handleStartProject = () => {
    navigate("/contactus");
  };

  const handleViewWork = () => {
    navigate("/ourwork");
  };

  const stats = [
    {
      value: "5+",
      label: "yearsInBusiness",
    },
    {
      value: "100+",
      label: "solutionsDelivered",
    },
    {
      value: "95%",
      label: "customerRetention",
    },
  ];

  return (
    <div className="relative min-h-screen flex flex-col items-center justify-center overflow-hidden bg-white dark:bg-[#080808] transition-colors duration-500">
      {/* Grid Background */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#8080800a_1px,transparent_1px),linear-gradient(to_bottom,#8080800a_1px,transparent_1px)] bg-[size:14px_24px] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_0%,#000_70%,transparent_100%)]" />

      {/* Gradient Blobs */}
      <div className="absolute top-20 left-1/4 w-72 h-72 rounded-full bg-blue-400/20 dark:bg-blue-600/10 blur-3xl" />
      <div className="absolute bottom-20 right-1/4 w-96 h-96 rounded-full bg-purple-400/20 dark:bg-purple-600/10 blur-3xl" />

      {/* Background Beams */}
      <BackgroundBeams className="opacity-40 dark:opacity-60" />

      {/* Floating Icons */}
      <div className="absolute inset-0 pointer-events-none hidden md:block overflow-hidden">
        <FloatingIcon delay={0} x="10%" y="20%">
          <FaReact className="w-10 h-10 text-sky-400" />
        </FloatingIcon>

        <FloatingIcon delay={1.5} x="85%" y="15%">
          <SiFlutter className="w-9 h-9 text-blue-400" />
        </FloatingIcon>

        <FloatingIcon delay={0.8} x="15%" y="70%">
          <FaNodeJs className="w-10 h-10 text-emerald-500" />
        </FloatingIcon>

        <FloatingIcon delay={2.3} x="80%" y="65%">
          <SiSap className="w-11 h-11 text-blue-600 dark:text-blue-400" />
        </FloatingIcon>

        <FloatingIcon delay={1.2} x="75%" y="30%">
          <FaDocker className="w-10 h-10 text-cyan-500" />
        </FloatingIcon>

        <FloatingIcon delay={1.9} x="25%" y="45%">
          <FaAws className="w-9 h-9 text-orange-400" />
        </FloatingIcon>
      </div>

      {/* Main Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-6 pt-32 pb-16 text-center flex flex-col items-center">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          animate="show"
          className="flex flex-col items-center gap-6"
        >
          {/* Badge */}
          <motion.div
            variants={itemVariants}
            className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-blue-500/20 dark:border-purple-500/20 bg-blue-50/50 dark:bg-purple-950/10 text-xs font-semibold text-blue-600 dark:text-purple-400 backdrop-blur-sm"
          >
            <span className="flex h-2 w-2 relative">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-blue-500"></span>
            </span>
            {t("welcome")}
          </motion.div>

          {/* Heading */}
          <motion.h1
            variants={itemVariants}
            className="text-4xl sm:text-6xl md:text-7xl font-extrabold tracking-tight font-sans text-slate-900 dark:text-white leading-[1.1] max-w-4xl"
          >
            {t("tagline")}{" "}
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 dark:from-blue-400 dark:via-purple-400 dark:to-pink-500">
              Softkel.
            </span>
          </motion.h1>

          {/* Subtitle */}
          <motion.p
            variants={itemVariants}
            className="text-base sm:text-xl text-slate-600 dark:text-slate-300 max-w-2xl font-normal leading-relaxed mt-2"
          >
            {t("subTagLine")}
          </motion.p>

          {/* Buttons */}
          <motion.div
            variants={itemVariants}
            className="flex flex-col sm:flex-row items-center gap-4 mt-6 w-full sm:w-auto"
          >
            <button
              onClick={handleStartProject}
              className="group relative flex items-center justify-center gap-2 px-6 py-3 w-full sm:w-auto text-sm font-semibold rounded-xl bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white shadow-lg transition-all duration-300 hover:-translate-y-0.5"
            >
              <span>{t("contact_us")}</span>
              <FiArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
            </button>

            <button
              onClick={handleViewWork}
              className="flex items-center justify-center gap-2 px-6 py-3 w-full sm:w-auto text-sm font-semibold rounded-xl bg-slate-50 hover:bg-slate-100 dark:bg-neutral-900 dark:hover:bg-neutral-800 text-slate-800 dark:text-slate-200 border border-slate-200 dark:border-neutral-800 transition-all duration-300 hover:-translate-y-0.5"
            >
              <span>{t("our_work")}</span>
            </button>
          </motion.div>
        </motion.div>

        {/* Stats */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{
            delay: 0.8,
            duration: 0.6,
          }}
          className="grid grid-cols-3 gap-6 sm:gap-12 mt-16 max-w-2xl w-full border-t border-slate-200/50 dark:border-neutral-800/50 pt-8"
        >
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <h4 className="text-2xl sm:text-3xl font-extrabold bg-clip-text text-transparent bg-gradient-to-b from-slate-900 to-slate-700 dark:from-white dark:to-neutral-400">
                {stat.value}
              </h4>

              <p className="text-xs sm:text-sm font-medium text-slate-500 dark:text-neutral-500 mt-1">
                {t(stat.label)}
              </p>
            </div>
          ))}
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div
        animate={{
          y: [0, 8, 0],
        }}
        transition={{
          duration: 1.8,
          repeat: Infinity,
          ease: "easeInOut",
        }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 pointer-events-none hidden sm:flex flex-col items-center gap-2 text-slate-400"
      >
        <span className="text-[10px] uppercase tracking-widest font-semibold opacity-60">
          Scroll Down
        </span>

        <FiChevronDown className="w-4 h-4" />
      </motion.div>
    </div>
  );
};

export default Header;